import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const latestArticles = articles.slice(0, 4);

export default function LatestArticles() {
  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            最新游戏资讯
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            了解最新网页游戏动态、深度评测和实用攻略
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-300/40 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 left-2 bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded-full whitespace-nowrap">
                  {article.category}
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1.5 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between mt-3 text-xs text-foreground-400">
                  <span>{article.date}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i> 5 分钟阅读
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
        <div className="text-center mt-10">
          <Link
            to="/article"
            className="inline-flex items-center gap-2 px-6 py-2.5 bg-secondary-500 text-background-50 rounded-full text-sm font-medium hover:bg-secondary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            查看更多资讯
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}